<template>
  <div>
    <v-main>
      <div
        class="col-md-12 ml-sm-auto col-lg-12 pa-4"
        v-show="dataintab === true"
      >
        <v-row class="pb-3">
          <v-col>
            <h2>รายงาน BroadCast</h2>
          </v-col>
          <v-col class="text-right">
              <v-btn
                @click="downloadTemplate"
                class="btn-color"
                color="indigo"
                width="150"
                outlined
              >
              <v-icon color="indigo">
                mdi-download
              </v-icon>
                Export Data
              </v-btn>
              <download-excel
              ref="downloadExcel"
              :data="export_data"
              :fields="export_fields"
              :type="exportType"
              :worksheet="exportWorksheet"
              :name="exportFileName"
              style="display: none"
            ></download-excel>
          </v-col>
        </v-row>

        <v-row class="pb-3 mt-5 ma-0 w-100 col-grid">
          <div class="pa-0">
            <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                :return-value.sync="date"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="dateRangeText"
                    label="ค้นหาตามวันที่"
                    prepend-inner-icon="mdi-calendar"
                    readonly
                    outlined
                    dense
                    v-bind="attrs"
                    v-on="on"
                    clearable
                    @click:clear="clearTextField()"
                    hide-details
                  ></v-text-field>
                </template>
                <v-date-picker v-model="date" no-title scrollable range>
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="menu = false">
                    Cancel
                  </v-btn>
                  <v-btn text color="primary" @click="$refs.menu.save(date)">
                    OK
                  </v-btn>
                  <!-- @click="$refs.menu.save(date), getDataFilter()" -->
                </v-date-picker>
              </v-menu>
          </div>
          <v-btn class="btn-grid" color="indigo" dark @click.stop="getData()">ค้นหา</v-btn>
        </v-row>

        <v-card>
          <v-data-table
            :headers="headers"
            :items="desserts"
            :items-per-page="5"
            class="elevation-1"
            :loading="loading"
            loading-text="Loading... Please wait"
          >
            <template v-slot:[`item.image`]="{ item }">
              <div style="display: flex !important; align-items: center !important;overflow-y: scroll;max-height: 100px;">
                <v-img v-if="item.pictureUrl !== null" :src="item.pictureUrl" max-height="80" max-width="80"></v-img>
                <br>
                <p style="padding-left: 1rem;">{{ item.message }}</p>
              </div>
            </template>
            <template v-slot:[`item.newLAST_DATE`]="{ item }">
              {{ format_dateNotime(item.newLAST_DATE) }}
            </template>
            <template v-slot:[`item.NumberOfRecipients`]="{ item }">
              <span>{{ recipientsText(item) }}</span>
            </template>
            <template v-slot:[`item.status`]="{ item }">
              <v-tooltip bottom v-if="isPartialSent(item)" max-width="320">
                <template v-slot:activator="{ on, attrs }">
                  <v-chip color="#e0a300" v-bind="attrs" v-on="on">
                    <h6 class="ma-0 bold text-white">partial</h6>
                  </v-chip>
                </template>
                <span>
                  ส่งสำเร็จ {{ item.NumberOfRecipients }} จาก {{ item.totalRecipients }} คน
                  ที่เหลือส่งไม่ได้เพราะ LINE userId ไม่ถูกต้อง กดดูรายละเอียดเพื่อดูรายชื่อ
                </span>
              </v-tooltip>
              <v-chip v-else :color="item.status.toLowerCase() === 'success'?'#3fb741d4':'#c44f4fd4'">
                <h6 class="ma-0 bold text-white">{{ item.status.toLowerCase() }}</h6>
              </v-chip>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <div class="text-end" style="white-space: nowrap;">
                <v-btn
                  v-if="item.status && item.status.toLowerCase() === 'pending'"
                  class="ma-2"
                  outlined
                  color="orange darken-2"
                  :loading="resendingId === item.id"
                  :disabled="resendingId !== null"
                  @click="resend(item)"
                >
                  <v-icon left>mdi-send</v-icon>
                  {{ resendingId === item.id ? 'กำลังส่ง...' : 'ส่งใหม่' }}
                </v-btn>
                <v-btn
                  class="ma-2"
                  outlined
                  color="indigo"
                  @click="showDetail(item)"
                >
                  <v-icon center> mdi-magnify</v-icon>
                </v-btn>
              </div>
            </template>
          </v-data-table>
        </v-card>

        <v-dialog
        v-model="dialogDetail"
        width="1100"
        content-class="dialog-pin-top"
        style=""
      >
        <v-card>
          <v-container>
            <div>
              <div
                style="
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                "
              >
                <v-btn class="mx-2" fab dark small color="grey lighten-1">
                  <v-icon dark @click="dialogDetail = false; dataDetail = []">
                    mdi-close
                  </v-icon>
                </v-btn>
                <v-text-field
                  v-model="memberSearch"
                  label="ค้นหา ชื่อ / เบอร์โทร"
                  prepend-inner-icon="mdi-magnify"
                  outlined
                  dense
                  clearable
                  hide-details
                  class="mx-4 mb-2" style="max-width: 420px"
                ></v-text-field>
                <v-btn color="indigo" style="margin-bottom: 10px;" outlined @click="exportTextFile(dataDetail)">
                        <v-icon left color="indigo">mdi-download</v-icon>

                          Export
                      </v-btn>
              </div>
            </div>

            <v-alert
              v-if="detailSentInfo"
              dense
              text
              :type="detailAlertType"
              class="mb-0"
            >
              <span v-if="detailSentInfo.thisSent">
                บรอดแคสต์นี้ส่งแล้ว {{ detailSentInfo.deliverableCount }} / {{ detailSentInfo.total }} คน
                <template v-if="detailSentInfo.invalidCount > 0">
                  — ส่งไม่ได้ {{ detailSentInfo.invalidCount }} คน เพราะ {{ detailSentInfo.invalidReason }}
                </template>
                <template v-if="detailSentInfo.recipientRows > detailSentInfo.total">
                  (นับตาม LINE userId ไม่ซ้ำ — มีสมาชิก {{ detailSentInfo.recipientRows }} รายชื่อที่ใช้ LINE ซ้ำกัน)
                </template>
              </span>
              <span v-else>
                บรอดแคสต์นี้ยังไม่ได้ส่ง (ผู้รับ {{ detailSentInfo.total }} คน)
                <template v-if="detailSentInfo.module === 'reward' && detailSentInfo.sentCount > 0">
                  — เคยได้รับของรางวัลนี้แล้ว {{ detailSentInfo.sentCount }} / {{ detailSentInfo.total }} คน
                </template>
                <template v-if="detailSentInfo.invalidCount > 0">
                  — มี {{ detailSentInfo.invalidCount }} คนที่ส่งไม่ได้ เพราะ {{ detailSentInfo.invalidReason }}
                </template>
              </span>
            </v-alert>

            <v-alert
              v-if="detailSentInfo && detailSentInfo.failedCount > 0"
              dense
              text
              type="warning"
              class="mt-2 mb-0"
            >
              <div
                style="display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 8px;"
              >
                <span>
                  มี {{ detailSentInfo.failedCount }} คนที่ส่งไม่สำเร็จ — {{ detailSentInfo.failedReason }}
                </span>
                <v-btn
                  small
                  color="warning"
                  :loading="resendFailedLoading"
                  :disabled="resendFailedLoading"
                  @click="resendFailed"
                >
                  <v-icon left small>mdi-refresh</v-icon>
                  ส่งซ้ำทั้งหมด ({{ detailSentInfo.failedCount }} คน)
                </v-btn>
              </div>
            </v-alert>

            <div
              style="
                display: flex;
                align-items: center;
                justify-content: center;
                margin-top: 10px;
              "
            >
              <v-data-table
                :headers="headerDetials"
                :items="dataDetail"
                :search="memberSearch"
                :custom-filter="memberFilter"
                :items-per-page="10"
                :loading="detailLoading"
              >
              <template v-slot:[`item.picture`]="{ item }">
                <div style="display: flex !important;align-items: center !important;height: 100px !important;">

                <v-img v-if="item.picture !== null" :src="item.picture" max-height="80" max-width="80"></v-img>
                <br>
                <p style="padding-left: 1rem;">{{ item.message }}</p></div>
              </template>
              <template v-slot:[`item.sentStatus`]="{ item }">
                <v-chip small :color="sentStatusColor(item.sentStatus)">
                  <span class="text-white">{{ item.sentStatus }}</span>
                </v-chip>
              </template>
              <template v-slot:[`item.sentReason`]="{ item }">
                <v-tooltip bottom v-if="item.sentReason" max-width="320">
                  <template v-slot:activator="{ on, attrs }">
                    <span class="reason-cell" v-bind="attrs" v-on="on">
                      {{ item.sentReason }}
                      <v-icon x-small color="#d9534f">mdi-information-outline</v-icon>
                    </span>
                  </template>
                  <span>{{ item.sentDetail || item.sentReason }}</span>
                </v-tooltip>
                <span v-else style="color: #bbbbbb;">-</span>
              </template>

            </v-data-table>
            </div>
          </v-container>
          <v-card-actions> </v-card-actions>
        </v-card>
      </v-dialog>
      </div>
    </v-main>
  </div>
</template>

<script>
import axios from 'axios' // api
import moment from 'moment' // แปลง date
import JsonExcel from 'vue-json-excel' // https://www.npmjs.com/package/vue-json-excel
import XLSX from 'xlsx'
import memberSearch from '@/mixins/memberSearch'

export default {
  mixins: [memberSearch],
  watch: {
    // ปิดป๊อปอัปรายชื่อแล้วล้างคำค้น เปิดรายการถัดไปจะได้ไม่ถูกกรองค้าง
    dialogDetail (open) {
      if (!open) this.memberSearch = ''
    }
  },
  components: {
    moment,
    downloadExcel: JsonExcel,
    XLSX
  },
  data () {
    return {
      desserts: [],
      menu: false,
      session: this.$session.getAll(),
      tab: null,
      dialogPackageMember: false,
      valid: true,
      menu1: false,
      dataintab: true,

      data_notify: [],
      date: [],
      headers: [
        { text: 'ข้อความที่ส่ง', value: 'image' },
        { text: 'จำนวนที่ส่ง', value: 'NumberOfRecipients' },
        { text: 'วันที่ส่งสำเร็จ', value: 'newLAST_DATE', align: 'center' },
        { text: 'สถานะ', value: 'status', align: 'center', width: '1px' },
        { text: '', value: 'actions', width: '1px' }
      ],
      ListReceipt: [],
      dialogData: false,
      data_receipt: [],
      loading: true,
      exportType: 'xls',
      exportFileName: 'Report_BroadCast',
      exportWorksheet: 'WorkSheet',
      export_data: [],
      dataDetail: [],
      dialogDetail: false,
      // export_fields: this.export_fields,
      export_fields: {
        ID: 'id',
        Module: 'module',
        'Refer ID': 'referId',
        'Picture Url': 'pictureUrl',
        Message: 'message',
        'Number Of Recipients': 'NumberOfRecipients',
        'Create Date': {
          field: 'CREATE_DATE',
          callback: (value) => {
            const formattedValue = value ? moment(String(value)).format('DD/MM/YYYY') : null
            if (formattedValue) {
              return moment(formattedValue, 'DD/MM/YYYY').add(543, 'years').format('DD/MM/YYYY')
            } else {
              return ''
            }
          }
        },
        'Create User': 'CREATE_USER'
      },
      headerDetials: [
        { text: 'โปร์ไฟล์', value: 'picture' },
        { text: 'บัญชีไลน์', value: 'name' },
        { text: 'ชื่อผู้ใช้', value: 'nameCustomer' },
        { text: 'เพศ', value: 'gender' },
        { text: 'อายุ', value: 'age' },
        { text: 'เบอร์โทรศัพท์', value: 'tel' },
        { text: 'ระดับ', value: 'LevelName' },
        { text: 'สถานะส่ง', value: 'sentStatus', align: 'center', width: 110 },
        { text: 'เหตุผล', value: 'sentReason', width: 220, sortable: false }
      ],
      export_data_member: [],
      export_field_member: {},
      txt: '',
      createDate: '',
      startDate: '',
      resendingId: null,
      detailSentInfo: null,
      detailLoading: false,
      detailItem: null,
      resendFailedLoading: false
    }
  },
  computed: {
    dateRangeText: {
      get () {
        return this.date.join(' - ')
      },
      set (value) {
        this.date = value ? value.split(' - ') : []
      }
    },
    detailAlertType () {
      if (!this.detailSentInfo) return 'info'
      if (!this.detailSentInfo.thisSent) return 'warning'
      return this.detailSentInfo.invalidCount > 0 ? 'warning' : 'success'
    }
  },
  beforeCreate () {
    if (!this.$session.exists()) {
      this.$router.push('/Core/Login')
    }
  },
  async mounted () {
    this.getData()
  },
  methods: {
    createNameFile () {
      const today = new Date()
      const formattedDate =
      today.getFullYear() +
      ('0' + (today.getMonth() + 1)).slice(-2) +
      ('0' + today.getDate()).slice(-2)

      this.exportFileName = `Report_BroadCast_${formattedDate}.xls`
    },

    downloadTemplate () {
      this.createNameFile()
      this.$nextTick(() => {
        this.$refs.downloadExcel.$el.click() // Trigger download
      })
    },

    getData () {
      let startDate = ''
      let endDate = ''

      if (this.date.length === 2) {
        this.date.sort()
        startDate = moment(this.date[0]).format('YYYY-MM-DD')
        endDate = moment(this.date[1]).format('YYYY-MM-DD')
      } else if (this.date.length === 1) {
        startDate = moment(this.date[0]).format('YYYY-MM-DD')
        console.log('this.date.length', startDate)
        endDate = moment(this.date[0]).format('YYYY-MM-DD')
        console.log('this.date.endDate', endDate)
      }

      let url = this.DNS_IP + '/broadcast/get?shopId=' + this.$session.getAll().data.shopId

      if (startDate && endDate) {
        url += `&CREATE_DATE=${encodeURIComponent(`${startDate},${endDate}`)}`
      }

      axios
        .get(url)
        .then((res) => {
          if (res.data.status === false) {
            this.desserts = []
            this.loading = false
            this.export_data = []
          } else {
            this.desserts = res.data.map((el) => {
              el.totalRecipients = this.countRecipients(el.lineUserId)
              return el
            })
            this.loading = false
            this.export_data = this.desserts
          }
        })
    },
    countRecipients (lineUserId) {
      let e = lineUserId
      if (typeof e === 'string') {
        try {
          e = JSON.parse(e)
        } catch (err) {
          return 0
        }
      }
      return Array.isArray(e) ? e.length : 0
    },
    isPartialSent (item) {
      if (!item.status || item.status.toLowerCase() !== 'success') return false
      const total = item.totalRecipients || 0
      const sent = item.NumberOfRecipients || 0
      return total > 0 && sent > 0 && sent < total
    },
    recipientsText (item) {
      const sent = item.NumberOfRecipients || 0
      const total = item.totalRecipients || 0
      return total > sent ? `${sent} / ${total}` : `${sent}`
    },
    sentStatusColor (status) {
      if (status === 'ส่งแล้ว') return '#3fb741d4'
      if (status === 'ส่งไม่ได้') return '#d9534f'
      if (status === 'ส่งไม่สำเร็จ') return '#f0ad4e'
      return '#9e9e9e'
    },
    resendFailed () {
      const item = this.detailItem
      if (!item || this.resendFailedLoading) {
        return
      }
      const count = (this.detailSentInfo && this.detailSentInfo.failedCount) || 0
      this.$swal({
        title: 'ส่งซ้ำผู้รับที่ส่งไม่สำเร็จ?',
        text: `ระบบจะส่งเฉพาะ ${count} คนที่ส่งไม่สำเร็จเพราะเน็ต/เซิร์ฟเวอร์ LINE ขัดข้อง คนที่ได้รับแล้วจะไม่ถูกส่งซ้ำ`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่ ส่งซ้ำ',
        cancelButtonText: 'ยกเลิก'
      })
        .then(async () => {
          this.resendFailedLoading = true
          try {
            const res = await axios.post(this.DNS_IP + '/broadcast/resend-failed', {
              id: item.id,
              user: this.$session.getAll().data.userName
            })
            const d = res.data || {}
            if (d.status) {
              this.$root.$emit('bpv-progress-start', { id: item.id })
              this.dialogDetail = false
              this.getData()
            } else {
              this.$swal('ส่งซ้ำไม่ได้', d.message || 'ไม่มีผู้รับที่ต้องส่งซ้ำ', 'info')
            }
          } catch (err) {
            console.error('resend-failed', err)
            this.$swal('ผิดพลาด', 'ส่งซ้ำไม่สำเร็จ กรุณาลองใหม่', 'error')
          } finally {
            this.resendFailedLoading = false
          }
        })
        .catch(() => {})
    },
    async showDetail (item) {
      this.txt = ''
      this.dataDetail = []
      this.createDate = ''
      this.detailSentInfo = null
      this.detailItem = item
      this.detailLoading = true
      try {
        this.createDate = moment(item.CREATE_DATE).format('DDMMYYYY')
        this.dialogDetail = true
        let e = item.lineUserId
        if (typeof e === 'string') {
          try {
            e = JSON.parse(e)
          } catch (parseError) {
            console.error('Error parsing JSON:', parseError.message)
            this.detailLoading = false
            return
          }
        }
        if (!Array.isArray(e)) {
          console.error('lineUserId is not an array:', e)
          this.dialogDetail = false
          this.detailLoading = false
          return
        }
        const lineUserIds = e.map(x => x.lineUserId || x.liffUserId)
        this.txt = lineUserIds

        let sentSet = new Set()
        try {
          const info = await axios.get(this.DNS_IP + '/broadcast/sent-info?id=' + item.id)
          if (info.data && info.data.status) {
            this.detailSentInfo = info.data
            sentSet = new Set(info.data.sentUserIds || [])
          }
        } catch (infoErr) {
          console.log('sent-info error', infoErr)
        }

        const response = await axios.post(this.DNS_IP + '/member/getIn', { liffUserId: lineUserIds })
        const members = Array.isArray(response.data) ? response.data : []
        const thisSent = this.detailSentInfo && this.detailSentInfo.thisSent
        const invalidSet = new Set(
          (this.detailSentInfo && this.detailSentInfo.invalidUserIds) || []
        )
        const invalidReason =
          (this.detailSentInfo && this.detailSentInfo.invalidReason) || 'ส่งไม่ได้'
        const invalidDetail =
          (this.detailSentInfo && this.detailSentInfo.invalidDetail) || invalidReason
        const failedSet = new Set(
          (this.detailSentInfo && this.detailSentInfo.failedUserIds) || []
        )
        const failedReason =
          (this.detailSentInfo && this.detailSentInfo.failedReason) || 'ส่งไม่สำเร็จ'
        const byUid = new Map()
        members.forEach(m => {
          const uid = m.liffUserId || m.lineUserId
          if (!uid) return
          if (byUid.has(uid)) {
            byUid.get(uid).sameLineUserIdCount += 1
            return
          }
          if (invalidSet.has(uid)) {
            m.sentStatus = 'ส่งไม่ได้'
            m.sentReason = invalidReason
            m.sentDetail = invalidDetail
          } else if (failedSet.has(uid)) {
            m.sentStatus = 'ส่งไม่สำเร็จ'
            m.sentReason = failedReason
            m.sentDetail = failedReason
          } else {
            m.sentStatus = thisSent || sentSet.has(uid) ? 'ส่งแล้ว' : 'ยังไม่ส่ง'
            m.sentReason = ''
            m.sentDetail = ''
          }
          m.sameLineUserIdCount = 1
          byUid.set(uid, m)
        })
        this.dataDetail = Array.from(byUid.values())
      } catch (err) {
        console.log('showDetail error', err)
        this.dataDetail = []
      }
      this.detailLoading = false
    },
    async exportTextFile (dataDetail) {
      console.log('headerDetials >>', this.headerDetials)
      console.log('dataDetail >>', dataDetail)
      let newData = []
      try {
        for await (const e of dataDetail) {
          let dataObj = {}
          for (let i = 1; i < this.headerDetials.length; i++) {
            console.log('asdasdasd', e)
            dataObj[this.headerDetials[i]['text']] = e[this.headerDetials[i]['value']]
            dataObj['เบอร์โทรศัพท์'] = e['tel'].replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3')
          }
          dataObj['lineUserId'] = e['liffUserId']
          console.log('dataObj', dataObj)
          newData.push(dataObj)
        }
        console.log('newData >>>', newData)
      } catch (err) {
        console.log('err', err)
      }
      const dataWS = XLSX.utils.json_to_sheet(newData)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, dataWS)
      // const dNow = new Date()
      XLSX.writeFile(wb, 'Report_Broadcast_' + this.createDate + '.xlsx')

      // const content = this.txt.join('\n')
      // const blob = new Blob([content], { type: 'text/plain' })
      // const link = document.createElement('a')
      // link.href = URL.createObjectURL(blob)
      // link.download = Report_BroadCast_Detail_${this.createDate}.txt
      // link.click()
    },
    clearTextField () {
      this.date = []
      this.getData()
    },
    resend (item) {
      if (this.resendingId) {
        return
      }
      this.$swal({
        title: 'ส่งบรอดแคสต์นี้อีกครั้ง?',
        text: `ระบบจะส่งเฉพาะรายการที่ยังไม่ถูกส่ง (ผู้รับ ${item.NumberOfRecipients || 0} คน) หากเคยส่งแล้วจะอัปเดตสถานะให้โดยไม่ส่งซ้ำ`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่ ดำเนินการ',
        cancelButtonText: 'ยกเลิก'
      })
        .then(async () => {
          this.resendingId = item.id
          this.$swal({
            title: 'กำลังส่งบรอดแคสต์...',
            text: 'กรุณารอสักครู่ ระบบกำลังส่งไปยังผู้รับ อย่าปิดหน้านี้หรือกดซ้ำ',
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: false,
            onOpen: () => {
              if (this.$swal.showLoading) {
                this.$swal.showLoading()
              }
            }
          })
          try {
            const res = await axios.post(this.DNS_IP + '/broadcast/resend', {
              id: item.id,
              user: this.$session.getAll().data.userName
            })
            const d = res.data || {}
            if (d.sent) {
              this.$swal('สำเร็จ', 'ส่งบรอดแคสต์ซ้ำเรียบร้อยแล้ว', 'success')
              this.getData()
            } else if (d.alreadySent) {
              this.$swal('รายการนี้ถูกส่งไปแล้ว', 'ระบบอัปเดตสถานะเป็นสำเร็จให้แล้ว (ไม่ส่งซ้ำเพื่อกันส่งซ้ำหาลูกค้า)', 'info')
              this.getData()
            } else if (d.incomplete) {
              this.$swal({
                title: 'ข้อมูลไม่ครบ',
                text: 'ข้อมูลบรอดแคสต์ไม่ครบสำหรับส่งซ้ำ ระบบจะพาไปหน้าสร้างพร้อมดึงข้อมูลเดิมไปให้ กรุณากรอกส่วนที่ขาดแล้วกดส่ง',
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#b3b1ab',
                confirmButtonText: 'ไปกรอกต่อ',
                cancelButtonText: 'ยกเลิก'
              })
                .then(() => {
                  this.$router.push('/BroadCast/Audience?resendId=' + item.id)
                })
                .catch(() => {})
            } else {
              this.$swal('ผิดพลาด', d.message || 'ส่งไม่สำเร็จ กรุณาลองใหม่', 'error')
            }
          } catch (e) {
            console.log('resend error', e)
            this.$swal('ผิดพลาด', 'ส่งไม่สำเร็จ กรุณาลองใหม่อีกครั้ง (ตรวจสอบว่า backend อัปเดตแล้วหรือยัง)', 'error')
          }
          this.resendingId = null
        })
        .catch(() => {})
    }
  }
}
</script>

<style scoped>
h3 {
  font-size: 18.72px !important;
}
.reason-cell {
  display: inline-block;
  color: #d9534f;
  font-size: 12px;
  line-height: 1.35;
  white-space: normal;
  word-break: normal;
  overflow-wrap: anywhere;
  cursor: help;
}
</style>



// WEBPACK FOOTER //
// src/components/Reports/reportBroadcast.vue